export const routes = {
    user: {
        GET_SITE_SETTINGS: 'api/site-settings',
        WALLET_BALANCE: 'api/user-info',
        AUTH_REFRESH: 'api/auth-refresh',
        LOGIN_API:'api/user-login',
        LOGIN_WITH_OTP:'api/login-with-otp',
        DEMO_LOGIN_API:'api/demo-user',
        LOGOUT_API:'api/logout',
        GET_FAVOURITE_LIST:'api/favorite-list',
        GET_OPEN_BETS: 'api/get-open-bets',
        GET_EVENT_EXPOSURES: 'api/get-event-book-and-fancy-exposures-by-event-id/:matchId',
        SAVE_BETS: 'api/save-bet',
        BET_CASHOUT: 'api/cashout',
        GET_FANCY_BOOK: 'api/get-fancy-book',
        MAKE_FAVOURITE: 'api/make-match-favorite',
        CHANGE_STAKE_VALUES: 'api/change-stake-values',
        GET_WALLET_GETWAY: 'api/get-payment-getway-iframe-url',
        GET_CASINO_GAMES: 'api/get-casino-games',
        GET_MY_MARKETS: 'api/get-my-markets/:sport_type',
        GET_PREMIUM_FANCY_URL: 'api/get-sap-premium-url/:sportId/:eventId',
        GET_SITE_RULES: 'api/get-site-rules',
        UPDATE_WALLET_TYPE: 'api/wallet-switch',
        SEND_OTP: 'api/send-otp',
        REGISTER: 'api/registration',
        FORGOT_PASSWORD: 'api/reset-forgot-password',
        CHANGE_MY_PASSWORD: 'api/change-my-password',
        CHANGE_PASSWORD_HISTORY: '/api/change-password-history',
        ACTIVITY_LOG: '/api/activity-logs',
        GET_SITE_VERSION: 'api/site-status-version',
        GET_MATKA_SINGLE_BETS: 'api/get-matka-single-bets/:id',
        SAVE_WORLI_MATKA_BET: 'api/save-worli-matka-bet',
        GET_STATEMENTS: 'api/get-statements',
        OPEN_BETS_EVENT_LISTING: 'api/open-bets-event-listing',
        GET_PROFIT_LOSS: 'api/get-user-pl-info',
        GET_PROFIT_LOSS_DETAIL: 'api/get-profit-loss-detail',
        GET_MARKET_BETS: 'api/get-market-bets',
        GET_PROFIT_LOSS_MATCH_DETAIL: 'api/get-user-match-statements',
        GET_LIVE_POCKER_URL: 'api/get-live-poker-url/:game_code',
        DREAM_CASINO: 'api/dreamcasino/load-game/:game_code/:sm_id',
        UNIVERSE_CASINO: 'api/universe/',
        GET_SPORTS_BOOK_URL: 'api/get-sap-sportsbook-url',
        // refrer & earn routes
        GET_REFER_CODE: 'api/get-refer-code',
        CHECK_BONUS_STATUS: 'api/check-bonus-status',
        USER_BONUS: 'api/user-bonus',
        REFERER_BONUS_STATEMENT: 'api/referer-bonus-statement',
        EVERY_USER_BONUS_STATEMENT: 'api/every-user-bonus-statement',
        BONUS_STATEMENT: 'api/bonus-statement',
        REDEEM_EVERY_USER_BONUS: 'api/redeem-every-user-bonus',
        REDEEM_REFERER_BONUS: 'api/redeem-referer-bonus',
        REDEEM_RECEIVER_BONUS: 'api/redeem-receiver-bonus',
        // search api
        // SEARCH: 'api/search',
        // wallet token
        GET_WALLET_GETWAY: 'api/get-payment-getway-token',
        // chat
        GET_CHATBOT_IFRAME: 'api/chatbot/get-iframe-url',
        GET_CHATBOT_IFRAME_GUEST: 'api/chatbot/get-iframe-url-for-guest',
        
        GET_THIRD_PARTY_API: 'api/load-third-party-url',
        GET_SEARCH_EVENTS: 'api/searching-event/:searchKey',
        GET_PROFIT_LOSS_PL_DETAIL: 'api/get-user-pl-statements',
        GET_ID_WALLET_WITHDRAW:'api/get-id/wallet-withdraw',
        GET_AUTO_UTR :'/api/wallet/get-auto-utr',

        // reedem bonus
        CLAIM_BONUS: 'api/claim-bonus',
        GET_USER_INFO : 'api/get-user-info',
        GET_STATEMENT_INFO: 'api/get-statements-info',
        },
    sports: {
        MATCHES_BY_SPORT_ID: 'v1/events/matches/:sport_id',
        GET_SPORTS: 'v1/sports/management/getSport',
        GET_MATCH_DETAILS: 'v1/events/matchDetails/:event_id',
        FIND_BY_IDS: 'v1/events/findByIds',
        INPLAY_MATCHES_COUNT: "v1/events/count",
        GET_MATKAS: '/v1/worli/public/matches',
        GET_MATKA_MARKETS: '/v1/worli/public/matches/:id/all/markets',
        UPCOMING_MATCHES_LIST: 'v1/events/sports/all',
        INPLAY_MATCHES_LIST: 'v1/events/matches/inplay',
        // GET_MATKA_SINGLE_BETS: '/get-matka-single-bets/:id'
    },
    fantasy: {
        FANTASY_SETUP_DATA: '/get-setup-data',
        GET_REMEMBERED_MATCHES: '/get-remembered-matches',
        ADD_MATCH_REMINDER: '/add-match-reminder',
        REMOVE_MATCH_REMINDER: '/remove-match-reminder',
        PLAYERS_LIST_API: '/get-match-players-list/:matchId',
        GET_MY_STAKES: '/get-my-stakes',
        UPDATE_MY_STAKES: '/update-my-stakes',
        ADD_MY_TEAM: '/add-my-team',
        UPDATE_MYTEAM_NAME: '/update-my-teamname',
        BET_DETAILS: '/get-match-bet-details',
        PLACE_BET: '/place-bet',
        MY_CONTESTS_LIST: '/get-my-contests',
        MY_CONTEST_BET_LIST: '/get-match-teams-and-bet-details',
        CANCEL_BET: '/cancel-bet',
        GET_TEAM_DETAILS: '/get-team-details/:id',
        MATCHES_LIST_API: '/get-matches-list',
        RESET_MYTEAM: '/reset-my-team'
    },
    wallet: {
        //Config
        GET_WALLET_CONFIG :'client/config',
        UPDATE_TXN_PASSWORD: 'client/update-txn-password',
        
        // Deposit
        PARENT_PAYMENT_METHODS :'client/accounts-master-list',
        PAYMENT_GATEWAY :'client/payment-url',
        // Deposit
        WALLET_DEPOSIT :'client/client-account-transaction',
        GET_AUTO_UTR :'/api/user/get-auto-utr',
        // Withdraw , Deposit
        CHANGE_STAKE_VALUES :'api/user/stakes/create',
        GET_STAKES :'api/user/stakes/list',
        // Withdraw
        PAYMENT_METHODS :'api/user/payment-methods', //1
        ADD_ACCOUNT :'client/create-client-account',
        WALLET_WITHDRAW :'api/user/withdraw-request', //2
        ACCOUNT_DETAILS :'client/client-account',
        DELETE_ACCOUNT :'client/delete-client-account/:accountId',
        BANK_DETAILS :'api/agent/bank-list',
        ONLY_BANK_STATUS :'api/user/withdrawal-only-bank-status',
        // GET_ID_WALLET_WITHDRAW:'api/get-id/wallet-withdraw',
        UPLOAD_AND_FETCH_QR_DATA: '/dir/settings/getSignedUrl',
        // History
        WALLET_HISTORY :'client/client-account-transaction',
        CANCEL_REQUEST :'client/cancel-transaction-request/:transactionId',
        CHECK_WITHDRAWAL_PASSWORD :'api/check-withdrawal-password', //3
        SENT_OTP_TO_MOBILE :'client/transaction-password/send-otp',
        VERIFY_MOBILE_OTP :'api/verify-mobile-otp', //4
        RESET_WITHDRAWAL_PASSWORD :'client/transaction-password/verify-otp',
    },
    bonus: {
        GET_BONUS_LOGS: 'api/v1/get-bonus-log',
        GET_BONUS_LOGS_DETAILS: 'api/v1/get-bonus-log-details',
        GET_USER_LOCKED_BONUS: 'api/v1/get-user-locked-bonus',
        GET_LOCKED_EARNED_BONUS: 'api/v1/get-locked-earn-bonus',
    },
    notification: {
        NOTIFICATIONS_LIST_API: 'api/get-notification',
        MARK_REDIRECT_NOTIFICATION: 'api/redirect-to-notification',
        UNREAD_NOTIFICATION_COUNT: 'api/get-unread-notifications-count',
        SUBSCRIBE_NOTIFICATION: 'api/subscribe-notification',
    }
};